export default __webpack_public_path__ + "static/media/clouds-right.cf3b1dbc.svg";